export interface DocumentItem {
    id: number;
    title: string;
    file: string;
    file_type: 'pdf' | 'excel' | string;
    file_url: string;
    created_at: string;
    document_date: string;
    category?: { id: number; title: string };
}

export interface CoordinatorDetail {
    id: number;
    firstname: string;
    lastname: string;
    avatar_url: string;
    services: { id: number; title: string }[];
    documents: DocumentItem[];
}

export interface ScheduleEntry {
    id: number;
    coordinator_id: number;
    coordinator_name: string;
    start_date: string;
    start_time: string | null;
    end_time: string | null;
    coordinator: CoordinatorDetail;
    service_name?: string;
}

export interface ApiResponse {
    code: number;
    status: boolean;
    message: string;
    data: Record<string, ScheduleEntry[]>;
}

export const isPdf = (fileType: string) =>
    fileType?.toLowerCase() === 'pdf';

export const isExcel = (fileType: string) =>
    ['excel', 'xlsx', 'xls', 'csv'].includes(fileType?.toLowerCase());

export const formatTime = (t: string | null): string => {
    if (!t) return '—';
    const [hh, mm] = t.split(':');
    const h = parseInt(hh, 10);
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${h % 12 || 12}:${mm} ${ampm}`;
};

export const formatDateKey = (year: number, month: number, day: number): string => {
    const m = String(month + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${year}-${m}-${d}`;
};

export const formatDisplayDate = (dateKey: string): string => {
    if (!dateKey) return '';
    const [y, m, d] = dateKey.split('-');
    return new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};